import type { FiltroApontamentosIbsCbs } from '@/services/RelatorioApontamentosIbsCbs';

/** O que a tela recusa antes de consultar; o servidor confere de novo. */
export function erroDoFiltroApontamentos(filtro: FiltroApontamentosIbsCbs): string | null {
  const competencia = /^\d{4}-(0[1-9]|1[0-2])$/;
  if (!competencia.test(filtro.competenciaInicial) || !competencia.test(filtro.competenciaFinal)) {
    return 'Informe as competências inicial e final.';
  }
  if (filtro.competenciaInicial > filtro.competenciaFinal) {
    return 'A competência inicial é posterior à final.';
  }
  if (filtro.cnpjContribuinte.replace(/\D/g, '').length !== 14) {
    return 'Selecione a loja no cabeçalho.';
  }
  return null;
}
